'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.object.entries");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

var AutoParser = require('./AutoParser.js');

var HttpInterface = require('./HttpInterface.js');

var RES_TYPES = {
  'application/json': 'json',
  'application/pdf': 'blob',
  'text/plain': 'text'
};

var XhrHttpIO =
/*#__PURE__*/
function (_HttpInterface$HttpIn) {
  _inheritsLoose(XhrHttpIO, _HttpInterface$HttpIn);

  function XhrHttpIO() {
    return _HttpInterface$HttpIn.apply(this, arguments) || this;
  }

  var _proto = XhrHttpIO.prototype;

  _proto.get = function get(path, params, responseType) {
    var request = new XMLHttpRequest();
    var endpoint = this.getEndpoint(path);
    var paramsQs = this.objToQuerystring(params);

    if (paramsQs) {
      endpoint = endpoint + paramsQs;
    }

    request.open('GET', endpoint);

    var authorization = this._getAuthorization(path);

    this.setupAuthorization(request, authorization);
    this.setupResponseType(request, responseType);
    this.setupAjaxCacheBuster(request);
    this.setupExtraHeaders(request);
    this.setupCustomHeaders(request);
    return this.promisify(request);
  };

  _proto.post = function post(path, params, responseType) {
    return this.doRequestWithBody('post', path, params, responseType);
  };

  _proto.put = function put(path, params, responseType) {
    return this.doRequestWithBody('put', path, params, responseType);
  };

  _proto.del = function del(path, params, responseType) {
    return this.doRequestWithBody('delete', path, params, responseType);
  };

  _proto.doRequestWithBody = function doRequestWithBody(method, path, params, responseType) {
    var request = new XMLHttpRequest();
    var endpoint = this.getEndpoint(path);
    request.open(method, endpoint);

    var authorization = this._getAuthorization(path);

    this.setupAuthorization(request, authorization);
    this.setupResponseType(request, responseType);
    this.setupExtraHeaders(request);
    this.setupCustomHeaders(request);
    return this.promisify(request, params);
  };

  _proto.getEndpoint = function getEndpoint(path) {
    if (path.includes('://')) {
      return path;
    }

    if (!path.startsWith('/')) {
      path = "/" + path;
    }

    return "" + this.apiPrefix + path;
  };

  _proto.promisify = function promisify(request, params) {
    var self = this;
    var p = new Promise(function (resolve, reject) {
      request.onload = self.onLoadHandler.bind(self, request, resolve, reject);
      request.onerror = self.onErrorHandler.bind(self, request, reject);
      request.send(JSON.stringify(params));
    });
    p.headers = request.requestHeaders;
    return p;
  };

  _proto.onLoadHandler = function onLoadHandler(request, resolve, reject) {
    if (request.status >= 200 && request.status < 300) {
      var autoParser = new AutoParser.AutoParser();
      request.body = autoParser.parse(request.response, request._msResponseType);
      resolve(request);
    } else {
      this.onErrorHandler(request, reject);
    }
  };

  _proto.onErrorHandler = function onErrorHandler(request, reject) {
    reject({
      status: request.status,
      statusText: request.statusText,
      error: request.error,
      request: request
    });
  };

  _proto.objToQuerystring = function objToQuerystring(obj) {
    if (typeof obj === 'undefined') {
      return;
    }

    var objectKeys = Object.keys(obj);

    if (objectKeys.length === 0) {
      return;
    }

    var querystring = objectKeys.map(function (k) {
      return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]);
    }).join('&');
    return '?' + querystring;
  };

  _proto.setupAjaxCacheBuster = function setupAjaxCacheBuster(request) {
    request.setRequestHeader('Expires', '0');
    request.setRequestHeader('Pragma', 'no-cache');
    request.setRequestHeader('Cache-Control', 'no-cache,no-store,must-revalidate');
  };

  _proto.setupAuthorization = function setupAuthorization(request, authorization) {
    request.withCredentials = true;

    if (!!authorization) {
      request.setRequestHeader('Authorization', authorization);
    }
  };

  _proto.setupResponseType = function setupResponseType(request, responseType) {
    var type = responseType || 'application/json';
    request.setRequestHeader('accept', type);
    request.setRequestHeader('content-type', 'application/json'); // PATCH for IE11 omitting request.responseType

    request._msResponseType = RES_TYPES[responseType] || 'json';
    request.responseType = request._msResponseType;
  };

  _proto.setupExtraHeaders = function setupExtraHeaders(request) {// Override in a subclass
  };

  _proto.setupCustomHeaders = function setupCustomHeaders(request) {
    if (!this.httpParams || !this.httpParams.headers) {
      return;
    }

    for (var _i = 0, _Object$entries = Object.entries(this.httpParams.headers); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
          name = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
      this.setHeader({
        request: request,
        name: name,
        value: value
      });
    }
  };

  _proto.setHeader = function setHeader(_ref) {
    var request = _ref.request,
        name = _ref.name,
        value = _ref.value;
    request.setRequestHeader(name, value);
  };

  return XhrHttpIO;
}(HttpInterface.HttpInterface);

exports.XhrHttpIO = XhrHttpIO;